import React from 'react';
import { Outlet } from 'react-router-dom';

import Frame from '../../../components/Library/Frame';
import useTitle from '../../../libs/useTitle';
import ScimIntegrationsList from './ScimIntegrationsList';

const SettingsScimIntegrations: React.FC = () => {
  useTitle('SCIM Integrations');

  return <>
    <div className='flex'>
      <Frame varient='primary' title='SCIM Integrations' className='w-200 mx-auto'>
        <ScimIntegrationsList />
      </Frame>
    </div>

    <Outlet />
  </>;
};

export default SettingsScimIntegrations;
